export default (X) => {
  return (options) => {
    let api = X.getApiByAlias(options.url);

    options.api = api || {
      type: X.API_TYPE.AJAX,
      uri: options.url,
    };

    return X.call(options);
  };
}



// WEBPACK FOOTER //
// ./src/plugins/ajax.js